/**
 * The payer directory search (`searchPayers` callable).
 */
import { httpsCallable } from 'firebase/functions'
import { functions } from '../config'

export interface PayerOption {
  name: string
  /** The payer ID sent to Stedi in the 270 request (the "primary payer ID"). */
  tradingPartnerServiceId: string
  /** Stedi's stable internal ID. Used to look up payer-specific rules
   *  (e.g. whether memberId is optional for this payer). Nullable because
   *  hardcoded RPA entries don't have a stediId. */
  stediId: string | null
  logoUrl: string | null
  /** Count of successful eligibility checks for this payer in the caller's
   *  clinic. Populated only when the caller passes `clinicId` to
   *  searchPayers. Drives the dropdown's most-used-first ordering. */
  usageCount?: number
}

export interface SearchPayersInput {
  /** At least 2 characters searches the directory; omitted returns the popular payers. */
  query?: string
  /** Adds the clinic's `usageCount` to each result. */
  clinicId?: string
}

/** Searches the payer directory. Throws when the search failed — never an empty list for a failure. */
export async function searchPayers(input: SearchPayersInput): Promise<{ payers: PayerOption[] }> {
  const fn = httpsCallable<SearchPayersInput, { payers: PayerOption[] }>(functions, 'searchPayers')
  const res = await fn(input)
  return res.data
}
